module.exports = __webpack_public_path__ + "static/media/Pong.18604353.jpg";